/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dark_Broad_Baboon_SavorInputs */

const fr_dark_broad_baboon_savor = /** @type {(inputs: Dark_Broad_Baboon_SavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer une notification`)
};

/**

* @param {Dark_Broad_Baboon_SavorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dark_broad_baboon_savor = /** @type {((inputs?: Dark_Broad_Baboon_SavorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dark_Broad_Baboon_SavorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dark_broad_baboon_savor(inputs)
});